<!-- @format -->

<register-company-applying-tag>
  <div class="contents">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_application">法人申請</h1>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="{ routes.makePath('top-tag') }" class="home">ホーム</a>
          </li>
          <li class="breadcrumb-item">法人申請</li>
        </ul>
      </div>
      <!--/.container_heading-->

      <div class="contents_block">
        <p>
          CROCO EDITECH
          HUBの法人登録をすると、同じ会社の複数人でのご利用が一層便利になります！
        </p>

        <h2 class="heading-02">法人登録のメリット</h2>
        <div class="column_container">
          <div class="column_03">
            <figure class="illust">
              <img src="/assets/img/ill_meritt_01.png" alt="" />
            </figure>
            <p>
              利用メンバーの予算や権限を
              <strong>ご利用サービスごとに設定が可能！</strong>
            </p>
          </div>
          <!--/.column_03-->
          <div class="column_03">
            <figure class="illust">
              <img src="/assets/img/ill_meritt_02.png" alt="" />
            </figure>
            <p>
              各メンバーが発注した
              <strong>全案件の進捗状況が管理画面で簡単に把握！</strong>
            </p>
          </div>
          <!--/.column_03-->
          <div class="column_03">
            <figure class="illust">
              <img src="/assets/img/ill_meritt_03.png" alt="" />
            </figure>
            <p>
              各メンバーの
              <strong>請求情報も管理画面で一元管理！</strong>
            </p>
          </div>
          <!--/.column_03-->
        </div>
        <!--column_container-->

        <hr class="partition" />

        <h2 class="heading-02">法人登録の手順</h2>
        <ol class="ordered_list01">
          <li class="ordered_list01-item">
            下記のフォームに必要情報を入力して送信。
          </li>
          <li class="ordered_list01-item">CROCO内で入力情報を元に審査。</li>
          <li class="ordered_list01-item">
            申請の際のアカウントを親アカウントとして設定し、法人利用を開始！
          </li>
        </ol>
        <p class="notice">
          ※審査の段階で情報の不備等で再申請のお願いや、申請の却下をすることがございます。予めご了承ください。
        </p>
        <company-form
          params="{ state.params }"
          errors="{ props.errors }"
          prefs="{ props.prefs }"
          confirmation="{ props.confirmation }"
        ></company-form>
        <!--/.application_form-->
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <script>
    import di from "dependeny-injection";
    import routes from "@model/menu-routes.js";
    import form from "@tags/parts/company-form.riot";

    export default {
      components: {
        "company-form": form,
      },
      state: {
        params: {},
      },
      onBeforeMount(props, state) {
        this.routes = routes;
      },
    };
  </script>
</register-company-applying-tag>
